import { useEffect } from 'react'
import { type TrackingType } from '@/services/trackingConst'
import { trackingService } from '@/services/trackingService'

interface UsePageBounceTrackingOptions {
  type: TrackingType
  enabled?: boolean
}

function usePageBounceTracking(options: UsePageBounceTrackingOptions) {
  const { type, enabled = true } = options

  useEffect(() => {
    if (!enabled) return

    let isPotentialBounce = true

    const handlePageHide = (event: PageTransitionEvent) => {
      if (!isPotentialBounce) return
      // bfcache resume and reload should not be counted as bounce.
      if (event.persisted) return
      const [entry] = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[]
      if (entry?.type === 'reload') return
      trackingService.trackByBeacon(type)
    }

    window.addEventListener('pagehide', handlePageHide)

    return () => {
      isPotentialBounce = false
      window.removeEventListener('pagehide', handlePageHide)
    }
  }, [enabled, type])
}

export default usePageBounceTracking
